// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"3597":"81be4b7e","8491":"7dc6565a"}[chunkId] + ".chunk.css";
};